import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './InformationBlock.module.css';
import { useInformationBlock } from './useInformationBlock';
import { InformationTitle } from './Components/InformationTitle/InformationTitle';
import { MainInformation } from './Components/MainInformation/MainInformation';
import { PeopleInformation } from './Components/PeopleInformation/PeopleInformation';
import { ModalUpdateInfoAboutObject } from '../../Modals/ModalUpdateInfoAboutObject/ModalUpdateInfoAboutObject';
import { InformationModals } from '../../Modals/InformationModals';

interface InformationBlockProps {
    classes?: string;
}

export const InformationBlock = ({ classes }: InformationBlockProps) => {
    const {} = useInformationBlock();

    return (
        <div id="project_information" className={classNames(cls.InformationBlock, [classes])}>
            <InformationModals />
            <InformationTitle />
            <MainInformation />
            <PeopleInformation />
        </div>
    );
};
